<script lang="ts">
	import Header from '#blocks/header.svelte'
	import Hero from '#blocks/hero.svelte'
	import { Storyblok } from '#library/storyblok.svelte.ts'
	import type { Video } from '#library/types.ts'

	interface Props {
		data: Storyblok<Video>
	}

	let { data }: Props = $props()

	const content = $derived(data.story?.content)
</script>

<Header />

{#if content?.video}
	<div class="contain">
		<Hero blok={{ video: content.video }} />
	</div>
{/if}
